import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Correspondant } from 'src/app/utils/interfaces/new/correspondant.interface';
import { CorrespondantFilter } from 'src/app/utils/interfaces/new/filtre-correspondant.interface';
import { SortEnum } from 'src/app/utils/enums/sort-enum';
import { FiltresService } from '../../services/filtres/filtres.service';
import { Filtres } from 'src/app/utils/interfaces/new/filtres.interface';
import { Paginated } from 'src/app/utils/interfaces/new/paginated.interface';
import { environment } from 'src/environments/environment';
import { SnackbarService } from '../snackbar/snackbar.service';
import { Observable, throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';

@Injectable({
  providedIn: 'root'
})
export class CorrespondantService {

  private _wait = (ms) => new Promise(res => setTimeout(res, ms));

  private isMock = environment.mock;

  private httpOptions = {
    withCredentials: true,
    observe: 'response' as 'response',
    headers: new HttpHeaders()
  };




  private apiUri = environment.basePath + '/user/';

  constructor(
    private _http: HttpClient,
    private _filtresService: FiltresService,
    private _snack: SnackbarService
  ) { }

  public async create(correspondant: Correspondant[]): Promise<string> {
    try {
      const res = await this._http.post(this.apiUri + 'correspondants', correspondant, this.httpOptions).toPromise();
      const idCorrespondant = res.body as string;
      return idCorrespondant;
    } catch (error) {
      this._snack.openSnackBar(error.error.message);
    }
  }



  public async find(filtre: Filtres = {
    perpage: 0,
    currentPage: 1,
    sortBy: 'nom',
    sortOrder: SortEnum.ASC
  } , ids?:string[], needle?:string|string[]): Promise<Correspondant[]> {
    try {
      this.httpOptions.headers = this._filtresService.setHeaders(filtre , ids, needle);
      const options = { headers: this.httpOptions.headers };
      const res = await this._http.get(this.apiUri + 'correspondants', options).toPromise();
      if (res) {
        const correspondants = res as Correspondant[];
        return correspondants;
      } else {
        throw new Error('Invalid response structure');
      }
    } catch (error) {
      this._snack.openSnackBar(error.error?.message || 'An error occurred');
      return [];
    }
  }

  public findPaginated(
    filtre: Filtres = {
      perpage: 30,
      currentPage: 1,
      sortBy: 'nom',
      sortOrder: SortEnum.ASC
    },
    idProfession?: string,idSpecialite?: string,needle?: string): Observable<{ data: Correspondant[], total: number }> {

    const take = filtre.perpage;
    const skip = take * (filtre.currentPage - 1);

    let headers = new HttpHeaders()
      .set('x-per-page', filtre.perpage.toString())
      .set('x-page', filtre.currentPage.toString())
      .set('x-sort-attribut', filtre.sortBy)
      .set('x-sort', filtre.sortOrder);

    if (needle?.trim()) {
      headers = headers.set('x-needle', needle.trim());
    }

    if (idProfession) {
      headers = headers.set('x-idprofession', idProfession);
    }

    if (idSpecialite) {
      headers = headers.set('x-idspecialite', idSpecialite);
    }

    return this._http.get<{ data: Correspondant[]; total: number }>(
      `${this.apiUri}correspondants/paginated`,
      { headers }
    ).pipe(
      catchError(error => {
        console.error('Erreur API:', error);
        return throwError(() => error);
      })
    );
  }

  public async findAnnuaireCorrespondants(): Promise<Correspondant[]> {
    try {
      const res = await this._http.get(environment.basePath + '/hypermed/correspondants', this.httpOptions).toPromise();
      const correspondants = res.body as Correspondant[];
      return correspondants;
    } catch (error) {
      this._snack.openSnackBar(error.error.message);
    }
  }

  public async correspondantsSearchFilters(filtres: CorrespondantFilter): Promise<Correspondant[]> {
    try {
      const res = await this._http.post(this.apiUri + 'correspondants/search/', filtres, this.httpOptions).toPromise();
      const correspondants = res.body as Correspondant[];
      return correspondants;
    } catch (error) {
      this._snack.openSnackBar(error.error.message);
    }
  }

  async findOne(id: string): Promise<Correspondant> {
    try {
      const res = await this._http.get(this.apiUri + 'correspondants/' + id, this.httpOptions).toPromise();
      const correspondant = res.body as Correspondant;
      return correspondant;
    } catch (error) {
      this._snack.openSnackBar(error.error.message);
    }
  }

  async update(id: string, updateInfos: Correspondant[]) {
    try {
      const res = await this._http.put(this.apiUri + 'correspondants/' + id, updateInfos, this.httpOptions).toPromise();
    } catch (error) {
      this._snack.openSnackBar(error.error.message);
    }
  }

  async merge(id: string, idsource: string, updateInfos: Correspondant) {
    try {
      const res = await this._http.put(
        `${this.apiUri}correspondants/fusion/${id}/${idsource}`,
        updateInfos,
        this.httpOptions
      ).toPromise();
    } catch (error) {
      this._snack.openSnackBar(error?.error?.message || 'Erreur lors de la fusion');
    }
  }

  async delete(id: string): Promise<void> {
    try {
      await this._http.delete(`${this.apiUri}correspondants/${id}`, this.httpOptions).toPromise();
    } catch (error) {
      throw error;
    }
  }
}
